import React, { useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';

import SidebarDDLocation from './SidebarDDLocation';
import SidebarDDTags from './SidebarDDTags';
import SidebarDDJobtypes from './SidebarDDJobtypes';
import SidebarDDExperience from './SidebarDDExperience';
import SidebarDDSalary from './SidebarDDSalary';

import CloseSidebar from "../../../assets/images/Job_Filters/CloseSidebar.png";

const JobSidebar = ({ selectedJobTypes, setSelectedJobTypes, minSalary, maxSalary, setMinSalary, setMaxSalary, selectedExperience, setSelectedExperience, handleRecommendedClick, handleResetRecommendations, handleOpenSidebar, selectedCities, setSelectedCities, cityOptions, clearFilters }) => {
    const [recommendedChecked, setRecommendedChecked] = useState(false);

    const experience = [
        { value: 'newgraduate', label: 'New Graduate' },
        { value: 'entrylevel', label: 'Entry-Level' },
        { value: 'associate', label: 'Associate' },
        { value: 'midsenior', label: "Mid-Senior Level" },
        { value: 'director', label: "Director" },
        { value: 'executive', label: "Executive" }
    ]

    const jobtypes = [
        { value: 'fulltime', label: 'Full-Time' },
        { value: 'parttime', label: 'Part-Time' },
        // { value: 'remote', label: 'Remote' },
        { value: 'freelance', label: 'Freelance' },
        { value: 'contractor', label: 'Contract' },
    ];

    const headcount = [
        { value: 'startup', label: '1 - 10' },
        { value: 'smallteam', label: '11 - 50' },
        { value: 'growing', label: '51 - 200' },
        { value: 'midsize', label: '201 - 500' },
        { value: 'enterprise', label: '500+' },
    ];

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setRecommendedChecked(checked);
        if (checked) {
            handleRecommendedClick();
        } else {
            handleResetRecommendations();
        }
    };

    return (
        <div className="hidden gap-5 p-4 sm:flex sm:flex-col overflow-y-auto bg-white w-full h-[calc(100vh-4rem)]">
            <div className="flex items-center justify-between gap-2 mb-0">
                <div className='flex w-full items-center justify-between gap-2'>
                    <h2 className="text-md font-dmsans font-bold text-[#5A6474]">Job Searcher</h2>
                    {/* <SearchIcon style={{ transform: 'scaleX(-1)' }} sx={{ color: '#5A6474' }} /> */}
                    <img onClick={handleOpenSidebar} className='cursor-pointer hover:bg-gray-200 p-2 rounded-full' src={CloseSidebar} alt="" />
                </div>


                {/* <button className='bg-[#4E73F8] hover:bg-blue-600 text-white text-sm font-dmsans font-normal px-4 py-1 rounded-md'>
                    Apply
                </button> */}
            </div>

            <div className='flex items-center justify-between'>
                <button 
                    onClick={clearFilters} 
                    className='flex items-center gap-1 font-dmsans font-medium text-sm text-[#3F57E0] hover:bg-blue-50 px-4 py-2 rounded-md transition-colors duration-300'
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Clear All Filters
                </button>
                {/* <button className='font-dmsans font-medium text-sm text-white bg-[#3F57E0] hover:bg-blue-700 px-3 py-1 rounded-full'>Apply Filters</button> */}
            </div>

            <div className='flex flex-col w-full gap-5'>
                {/* <label className="flex items-center gap-2 text-[#5A6474] text-sm font-dmsans font-medium cursor-pointer">
                    <input
                        type="checkbox"
                        checked={recommendedChecked}
                        onChange={handleCheckboxChange}
                        className="w-4 h-4"
                    />
                    Recommended for me
                </label> */}

                <div className="bg-white w-full rounded-lg text-xl">
                    <SidebarDDSalary
                        minSalary={minSalary}
                        maxSalary={maxSalary}
                        setMinSalary={setMinSalary}
                        setMaxSalary={setMaxSalary}
                    />
                </div>

                <div className="bg-[#FFFFFF] w-full flex flex-col rounded-lg text-xl gap-2">
                    <p className='font-dmsans font-bold text-sm text-left'>Location</p>
                    <SidebarDDLocation
                        selectedCities={selectedCities}
                        setSelectedCities={setSelectedCities}
                        cityOptions={cityOptions}
                    />
                </div>

                <div className="bg-[#FFFFFF] w-full shadow-md rounded-lg text-xl">
                    <SidebarDDJobtypes
                        title="Job Type"
                        options={jobtypes}
                        selectedOptions={selectedJobTypes}
                        setSelectedOptions={setSelectedJobTypes}
                    />
                </div>

                <div className="bg-[#FFFFFF] w-full shadow-md rounded-lg text-xl">
                    <SidebarDDExperience
                        title="Experience Label"
                        options={experience}
                        selectedExperience={selectedExperience}
                        setSelectedExperience={setSelectedExperience}
                    />
                </div>


                {/* <div className="bg-[#FFFFFF] w-full shadow-md rounded-lg text-xl">
                    <SidebarDDTags />
                </div> */}

                {/* <div className="bg-[#FFFFFF] w-full shadow-md rounded-lg text-xl">
                    <SidebarDDJobtypes title="Headcount" options={headcount} />
                </div> */}
            </div>
        </div >
    )
}

export default JobSidebar